export default function (str, chars, append = '…') {
  const truncatedString = str.substring(0, chars).trim();
  if (truncatedString.length === str.length) {
    return truncatedString;
  }
  return `${truncatedString}${append}`;
}
